/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form[name!=export_order_to_csv]').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $(document)
        .on('submit', 'form[name=delete-item]', function (e) {
            e.preventDefault();

            const modalDeleteVehicle = $(this).closest('.modal#deleteVehicleModal');
            const isDeleteVehicle = modalDeleteVehicle.length > 0;
            isDeleteVehicle && modalDeleteVehicle.modal('hide');
            const confirmTitle = $(this).data('confirm_title') || 'Confirm';
            const confirmBody = $(this).data('confirm_body') || 'Are you sure you want to delete this item?';
            Swal.fire({
                padding: 0,
                width: isDeleteVehicle ? 'auto' : ($(this).data('width') ?? 'auto'),
                title: !isDeleteVehicle && confirmTitle,
                html: `<h3 class="mt-3 mb-3 font-weight-normal ${$(this).data('message_class') ?? ''}">${confirmBody}</h3>`,
                showCancelButton: true,
                confirmButtonText: $(this).data('confirm_button') || 'Confirm Delete',
                cancelButtonText: $(this).data('cancel_button') || 'Cancel',
                // icon: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-success min-width-110 font-weight-bold text-nowrap',
                    cancelButton: 'btn btn-danger mr-3 min-width-110 font-weight-bold text-nowrap',
                    title: 'swal2-title mb-0 border pb-3 h3 font-2xl ' + ($(this).data('title_class') ?? ''),
                    header: 'swal2-header border-bottom pt-3 pb-3 ' + ($(this).data('header_class') ?? ''),
                    content: 'swal2-content pt-3 pb-3',
                    actions: 'swal2-actions border-top pt-3 pb-3 mt-0 w-100',
                    htmlContainer: 'm-0 p-3',
                },
                showClass: {
                    popup: '',
                },
                hideClass: {
                    popup: '',
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    isDeleteVehicle && modalDeleteVehicle.modal('show');
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            const confirmTitle = $(this).data('confirm_title') || 'Confirm';
            const confirmBody = $(this).data('confirm_body') || 'Are you sure you want to delete this item?';
            Swal.fire({
                padding: 0,
                title: confirmTitle,
                html: `<h3 class="mt-3 mb-3 font-weight-normal">${confirmBody}</h3>`,
                showCancelButton: true,
                confirmButtonText: $(this).data('confirm_button') || 'Confirm Delete',
                cancelButtonText: $(this).data('cancel_button') || 'Cancel',
                // icon: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-success w-25 font-weight-bold text-nowrap',
                    cancelButton: 'btn btn-danger mr-3 w-25 font-weight-bold text-nowrap',
                    title: 'swal2-title mb-0 border pb-3',
                    header: 'swal2-header border-bottom pt-3 pb-3',
                    content: 'swal2-content pt-3 pb-3',
                    actions: 'swal2-actions border-top pt-3 pb-3 mt-0 w-100',
                    htmlContainer: 'm-0 p-3',
                },
                showClass: {
                    popup: '',
                },
                hideClass: {
                    popup: '',
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
            /**
             * Add an 'are you sure' pop-up to any button/link
             */
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'info',
            }).then((result) => {
                result.value && window.location.assign($(this).attr('href'));
            });
        });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="' + hash + '"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();
});
